import { Box, Divider, Skeleton } from '@mui/material';
import PropTypes from 'prop-types';
import { homeColors } from '../style/homeStyles';

// Placeholder del simulador mientras llega la matriz de montos. Replica el alto de cada bloque
// real para que la tarjeta no salte al renderizar.
const AmountSimulatorSkeleton = ({ isMobile }) => {
  const skeletonSx = { backgroundColor: 'rgba(31,27,29,0.07)' };
  const smallTextHeight = isMobile ? 18 : 20;

  return (
    <Box aria-busy="true" aria-live="polite">
      <Skeleton variant="rounded" width="62%" height={isMobile ? 22 : 24} sx={skeletonSx} />
      <Skeleton
        variant="rounded"
        width="84%"
        height={smallTextHeight}
        sx={{ ...skeletonSx, marginTop: '6px' }}
      />

      <Skeleton
        variant="rounded"
        width="58%"
        height={isMobile ? 44 : 56}
        sx={{ ...skeletonSx, marginTop: isMobile ? '18px' : '24px', marginX: 'auto' }}
      />

      <Skeleton
        variant="rounded"
        height={12}
        sx={{
          ...skeletonSx,
          borderRadius: '999px',
          marginTop: isMobile ? '26px' : '30px',
          width: `calc(100% - ${isMobile ? 26 : 30}px)`,
          marginX: 'auto',
        }}
      />

      <Box sx={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', marginTop: '10px',
      }}
      >
        <Skeleton variant="rounded" width={72} height={smallTextHeight} sx={skeletonSx} />
        <Skeleton variant="rounded" width={72} height={smallTextHeight} sx={skeletonSx} />
      </Box>

      <Divider sx={{ borderColor: homeColors.line, marginTop: isMobile ? '16px' : '20px' }} />

      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        marginTop: isMobile ? '14px' : '16px',
      }}
      >
        <Skeleton variant="rounded" width={110} height={smallTextHeight} sx={skeletonSx} />
        <Skeleton variant="rounded" width={130} height={smallTextHeight} sx={skeletonSx} />
      </Box>

      <Skeleton
        variant="rounded"
        height={50}
        sx={{
          ...skeletonSx, borderRadius: '12px', marginTop: isMobile ? '16px' : '20px', width: '100%',
        }}
      />

      <Skeleton
        variant="rounded"
        width={160}
        height={18}
        sx={{ ...skeletonSx, marginTop: '14px', marginX: 'auto' }}
      />
    </Box>
  );
};

AmountSimulatorSkeleton.propTypes = {
  isMobile: PropTypes.bool,
};

AmountSimulatorSkeleton.defaultProps = {
  isMobile: false,
};

export default AmountSimulatorSkeleton;
